<template>
  <div class="official">
    <!-- 已發布帖子 -->
    <card v-for="item in topicsList" :key="item.id" :cardData="item"></card>

  </div>
</template>

<script>

import Vue from "vue";
import get from "@/api/get";
import card from "../../card";
export default {
  name: "official",
  components: { card },
  data() {
    return {
      name: "official",
    };
  },
  props: ["topicsList"],
  async mounted() {
    if(this.$store.state.token == ''){
        const promise = new Promise((resolve)=>{
        this.resolveHander = resolve;
      })
      await promise;
    }
    this.init();
  },
  methods: {
    init(){
      
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
